export type LiveKitPageLeaveReason = 'page-leave' | 'page-hide'

export interface PageHideLike {
  persisted?: boolean
}

export function getPageHideReason(event?: PageHideLike | null): LiveKitPageLeaveReason | null {
  if (event?.persisted === true) {
    return null
  }

  return 'page-hide'
}

export function getPageLeaveDisconnectDelayMs(
  reason: LiveKitPageLeaveReason,
  gracePeriodMs: number
): number {
  return reason === 'page-leave' ? 0 : gracePeriodMs
}

/**
 * Whether a page-leave teardown should be deferred (skipped) because a modal/dialog is
 * keeping the user in the room.
 *
 * SC-246 (whiteboard): the whiteboard is a long-lived in-page iframe modal. The connector's
 * dialog grace is a fixed window anchored to the last dialog open/close event
 * (`withinDialogGrace`); a whiteboard open longer than that window loses its protection, so a
 * transient page-hide can tear LiveKit down mid-session ("disconnects while using the
 * whiteboard"). Also consulting a live "is any dialog currently open" flag (`dialogOpen`)
 * closes that gap without weakening genuine page-unload teardown (which fires with no dialog
 * open).
 */
export function shouldDeferPageLeaveDisconnect(input: {
  dialogOpen: boolean
  withinDialogGrace: boolean
}): boolean {
  return input.dialogOpen || input.withinDialogGrace
}
